class csCosts {
    constructor(
        cat,
        id,
        name,
        ws
    
    ){
        this.cat =cat
        this.id =id 
        this.name =name
        this.ws =ws
      

    
    }
    static fromJson({
        cat,
        csCostoId,
        nombre,
        ws,
    }){
        return new csCosts(
        cat,
        csCostoId,
        nombre,
        ws,
            
        )
    }
    }
    export default csCosts
    